import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppMessageService } from '../../../services/message.service';
import { SpinnerService } from '../../../components/spinner/spinner.service';
import { Project } from '../../../entities/project.entity';
import { ApiService } from '../../../services/api.service';
import { Customer } from '../../../entities/customer.entity';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
	selector: 'change-customer-dialog',
	template: `
		<div class="flex items-center mb-1" mat-dialog-title style="margin-bottom:15px">
			<p class="flex-auto text-lg font-medium">{{"PROJECT.CHANGE_CUSTOMER" | translate}}</p>
			<button mat-dialog-close mat-icon-button type="button">
				<mat-icon size="24px">close</mat-icon>
			</button>
		</div>

		<mat-dialog-content>

			<form class="form">

				<mat-form-field appearance="outline" class="block w-full">
					<mat-label>{{"PROJECT.CUSTOMER" | translate}}</mat-label>
					<input type="text" matInput [matAutocomplete]="auto" [formControl]="customerCtrl">
					<mat-autocomplete #auto="matAutocomplete" [displayWith]="customerDisplayFn">
						<mat-option *ngFor="let option of filteredCustomers | async" [value]="option">
							{{ option.name }}
						</mat-option>
					</mat-autocomplete>
				</mat-form-field>

			</form>

		</mat-dialog-content>

		<div fxLayout="row">
			<span fxFlex="auto"></span>
			<button (click)="save()" color="primary" mat-flat-button type="button">
				<span>{{"BUTTON.SAVE" | translate}}</span>
				<!--<ic-icon [icIcon]="icSend" [inline]="true" class="ml-2" size="16px"></ic-icon>-->
			</button>
		</div>
	`,
	styleUrls: [
	],
	animations: [
	],
	// encapsulation: ViewEncapsulation.None
})
export class ChangeCustomerDialogComponent implements OnInit {
	project: Project;
	customers = [] as Customer[];
	customerCtrl = new FormControl();
	filteredCustomers: Observable<Customer[]>;

	constructor(
		private dialogRef: MatDialogRef<ChangeCustomerDialogComponent>,
		private apiService: ApiService,
		private spinner: SpinnerService,
		private appMessageService: AppMessageService,
		@Inject(MAT_DIALOG_DATA) public data: any,
	) { }

	async ngOnInit() {
		this.project = this.data.project as Project;
		this.customers = await this.apiService.get("customers") as Customer[];
		this.filteredCustomers = this.customerCtrl.valueChanges.pipe(
			startWith(''),
			map(value => (typeof value === 'string' ? value : value.name)),
			map(name => (name ? this.filterCustomers(name) : this.customers.slice())),
		);
		this.customerCtrl.setValue(this.project.customer);

	}

	private filterCustomers(name: string): Customer[] {
		const filterValue = name.toLowerCase();
		return this.customers.filter(option => option.name.toLowerCase().includes(filterValue));
	}

	close(data) {
		this.dialogRef.close(data);
	}

	async save() {
		console.log('Change Customer');

		const customer = this.customerCtrl.value;

		if (!customer || !customer.id) {
			this.appMessageService.showInfoDialog('Please select a customer or create a new one first');
		}
		else {
			try {
				this.project.customerId = customer.id;
				this.project.customer = customer;
				await this.apiService.put("projects", this.project);
				this.appMessageService.showToastSuccess('Customer updated');
				this.close(this.project);
			} catch (e) {
				console.error(e);
			}
		}
	}

	customerDisplayFn(customer: Customer): string {
		return customer && customer.name ? customer.name : '';
	}

}
